import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'toastr/build/toastr.css';
import 'rsuite/dist/rsuite.min.css';
import './css/main.css';
import './css/kislev.css';
import 'react-pro-sidebar/dist/css/styles.css';

import App from './components/App';
import reportWebVitals from './reportWebVitals';
import generateStore from './redux/store';

const store = generateStore();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
